import { render, staticRenderFns } from "./UiModalConfirm.vue?vue&type=template&id=4135de79&"
import script from "./UiModalConfirm.vue?vue&type=script&lang=js&"
export * from "./UiModalConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports